var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.mode === "DESIGN"
      ? _c(
          "div",
          { staticClass: "disabled-box max-width" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn-upload",
                attrs: { size: "mini", icon: "iconfont el-icon-plus" },
              },
              [_vm._v("选择人员")]
            ),
          ],
          1
        )
      : _c("div", [
          !_vm.readerMode || _vm.perm === "E"
            ? _c(
                "div",
                {
                  staticClass: "max-width",
                  class: { "no-focus": _vm.hiddenError },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "select-u",
                      attrs: {
                        "value-key": "name",
                        disabled: _vm.perm === "R",
                        placeholder: "选择人员",
                        size: "small",
                        multiple: "",
                        "popper-class": "hidden",
                      },
                      on: { "remove-tag": _vm.removeTag },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.selectUser.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm._value,
                        callback: function ($$v) {
                          _vm._value = $$v
                        },
                        expression: "_value",
                      },
                    },
                    _vm._l(_vm._value, function (wc, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: wc.serial + wc.name, value: wc },
                      })
                    }),
                    1
                  ),
                  _c("org-picker", {
                    ref: "orgPicker",
                    attrs: {
                      title: "选择人员",
                      multiple: true,
                      selected: _vm._value,
                    },
                    on: { ok: _vm.selected, cancel: _vm.cancel },
                  }),
                ],
                1
              )
            : _c("div", { staticClass: "form-item-text" }, [
                _vm._v(" " + _vm._s(_vm.valueText) + " "),
              ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }